import BaseStore from '../BaseStore';

class InMemoryStore extends BaseStore {
  constructor(name, version) {
    super(name, version);
    this.store = new Map();
  }

  set(key, data, expiresAt) {
    this.store.set(key, { data, expiresAt });
    this.debugMsg('Mem 🖊️ added', key);
  }

  // This is a put operation so the entire object will be replaced.
  // That makes it the same as set for a JS MAP
  update(key, data, expiresAt) {
    this.set(key, data, expiresAt);
    this.debugMsg('Mem 🖊️ updated', key);
  }

  get(key) {
    return new Promise((resolve, reject) => {
      try {
        const result = this.store.get(key);
        this.debugMsg('Mem 🔎', key, result);
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  }

  async upsert(key, data, expiresAt) {
    const result = await this.get(key);
    if (result === undefined) {
      this.set(key, data, expiresAt);
    } else {
      this.update(key, data, expiresAt);
    }
  }

  delete(key) {
    return new Promise((resolve, reject) => {
      try {
        const result = this.store.delete(key);
        this.debugMsg('Mem ❌ deleted', key);
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  }

  deleteStartsWith(substring) {
    return new Promise((resolve, reject) => {
      try {
        [...this.store.keys()].forEach((key) => {
          if (key.indexOf(substring) === 0) {
            this.store.delete(key);
          }
        });
        this.debugMsg('Mem ❌ deleted all records starting with', substring);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  // Delete all entries with the prefix
  clear() {
    this.store.clear();
    this.debugMsg('Mem ❌ All data deleted.');
  }
}

export default InMemoryStore;
